/** Auth API calls (login / logout / change-password). */
import { http } from "@/lib/api";
import type { MetaUser } from "@/lib/meta";

export interface LoginResponse {
  access_token: string;
  token_type: string;
  user: MetaUser;
}

export async function apiLogin(
  email: string,
  password: string,
): Promise<LoginResponse> {
  const { data } = await http.post<LoginResponse>("/auth/login", { email, password });
  return data;
}

export async function apiLogout(): Promise<void> {
  await http.post("/auth/logout");
}

export async function apiChangePassword(
  currentPassword: string,
  newPassword: string,
): Promise<void> {
  await http.post("/auth/change-password", {
    current_password: currentPassword,
    new_password: newPassword,
  });
}

export async function apiForgotPassword(email: string): Promise<void> {
  await http.post("/auth/forgot-password", { email });
}

export async function apiResetPassword(token: string, newPassword: string): Promise<void> {
  await http.post("/auth/reset-password", { token, new_password: newPassword });
}
